const LeThanhThanh = () => {
  const trainingPrograms = [
    'Mật mã tài năng',
    'Nuôi dạy con 4.0',
    'Ứng dụng Sinh trắc vân tay bản Bảo hiểm nhân thọ',
    'Cha mẹ hoàn hảo',
    'Khám phá bản thân - Kiến tạo sự nghiệp',
    'Cha mẹ thông thái - dạy con thành tài',
    'Thấu hiểu để yêu thương',
    'Đào tạo chuỗi chương trình "Hành trình chuyên gia"',
    'Đào tạo Sinh trắc vân tay ứng dụng vào đời sống',
  ];

  const achievements = [
    'Đào tạo hơn 1,200 Chuyên viên Sinh trắc vân tay toàn quốc',
    'Đồng hành hơn 3,000+ Khách hàng toàn quốc',
    'Đào tạo bán hàng, xây dựng đội nhóm cho hơn 3,500+ đối tác kinh doanh toàn quốc',
  ];

  const stvtApplications = [
    { name: 'Nuôi dạy con', icon: '👶' },
    { name: 'Bán hàng', icon: '💼' },
    { name: 'Hướng nghiệp', icon: '🎯' },
    { name: 'Xây dựng đội nhóm kinh doanh', icon: '👥' },
  ];

  const umitProjects = [
    {
      title: 'C.O.T Bảo hiểm nhân thọ',
      description: '3 năm liên tiếp: 2020, 2021, 2022',
      icon: '🏆',
    },
    {
      title: 'Dự án "Cha mẹ bình thường - Nuôi con xuất sắc"',
      description: 'Hơn 40+ chủ đề làm cha mẹ, Khóa học trực tuyến',
      icon: '👨‍👩‍👧‍👦',
    },
  ];

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            LÊ THANH THANH
          </h2>
          <p className="text-xl text-primary font-semibold mb-4">
            NHÀ ĐÀO TẠO, SALES & TRAINING DIRECTOR (ONE SKY / UMIT)
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Profile Image */}
          <div className="relative">
            <div className="bg-gradient-to-br from-primary to-primary-700 rounded-2xl p-8 text-white text-center">
              <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white/20">
                <img
                  src="/assets/images/Le-Thanh-Thanh.jpg"
                  alt="Lê Thanh Thanh - Sales & Training Director"
                  className="w-full h-full object-cover"
                  onError={e => {
                    // Fallback to placeholder if image fails to load
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="w-full h-full bg-white/20 rounded-full hidden items-center justify-center">
                  <svg
                    className="w-24 h-24 text-white/80"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              <h4 className="text-2xl font-bold mb-2">Lê Thanh Thanh</h4>
              <p className="text-primary-100 font-medium">
                Sales & Training Director
              </p>
              <p className="text-primary-100 text-sm mt-2">ONE SKY / UMIT</p>
            </div>

            {/* Experience Summary */}
            <div className="mt-6 bg-white rounded-2xl p-6 shadow-lg">
              <h4 className="text-xl font-bold text-primary mb-4">
                Kinh nghiệm chuyên môn
              </h4>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-secondary rounded-full mr-3"></span>
                  <span className="text-gray-700">
                    <strong>Sales & Training Director</strong>
                  </span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-secondary rounded-full mr-3"></span>
                  <span className="text-gray-700">
                    Hơn <strong>07 năm</strong> kinh nghiệm trong lĩnh vực sinh
                    trắc vân tay ứng dụng
                  </span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-secondary rounded-full mr-3"></span>
                  <span className="text-gray-700">
                    <strong>05 năm</strong> trong lĩnh vực đào tạo
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            {/* Training Programs */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg">
              <h4 className="text-2xl font-bold text-primary mb-6">
                Các chương trình đã đào tạo
              </h4>
              <div className="grid gap-3">
                {trainingPrograms.map((program, index) => (
                  <div
                    key={index}
                    className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-primary-50 transition-colors duration-300"
                  >
                    <svg
                      className="w-4 h-4 text-primary mr-3 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-gray-700 text-sm font-medium">
                      {program}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Achievements */}
        <div className="bg-primary-50 rounded-2xl p-6 md:p-8 mt-16">
          <h4 className="text-2xl font-bold text-primary mb-6">
            Thành tựu & Kinh nghiệm
          </h4>
          <div className="space-y-4">
            {achievements.map((achievement, index) => (
              <div key={index} className="flex items-start">
                <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <span className="text-gray-900 font-bold text-sm">
                    {index + 1}
                  </span>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {achievement}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* STVT Applications */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
            Các lĩnh vực ứng dụng STVT (Sinh Trắc Vân Tay)
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
            {stvtApplications.map((app, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 text-center shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-105"
              >
                <div className="text-3xl mb-3">{app.icon}</div>
                <div className="text-gray-700 font-semibold text-sm">
                  {app.name}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* UMIT Projects */}
        <div className="bg-gradient-to-r from-primary to-primary-700 rounded-2xl p-8 md:p-12 text-white">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-8">
            Thành tích & Dự án nổi bật (UMIT)
          </h3>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            {umitProjects.map((project, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6"
              >
                <div className="text-3xl mb-4 text-center">{project.icon}</div>
                <h4 className="text-xl font-bold mb-3 text-center">
                  {project.title}
                </h4>
                <p className="text-primary-100 text-center">
                  {project.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 max-w-md mx-auto">
              <h4 className="text-xl font-bold mb-4">Vai trò tại UMIT</h4>
              <div className="space-y-2 text-primary-100">
                <p>• Master Coach & Trainer UMIT</p>
                <p>• Agency Development Director</p>
              </div>
              <div className="mt-6 pt-4 border-t border-white/20">
                <p className="text-sm text-primary-100 mb-2">Liên hệ UMIT:</p>
                <div className="flex items-center justify-center space-x-4 text-sm">
                  <span>📞 0945 86 3144</span>
                  <span>🌐 www.umit.vn</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeThanhThanh;
